// ** Routes Imports
import AppRoutes from "./Apps";
import FormRoutes from "./Forms";
import PagesRoutes from "./Pages";
import TablesRoutes from "./Tables";
import ChartMapsRoutes from "./ChartsMaps";
import DashboardRoutes from "./Dashboards";
import UiElementRoutes from "./UiElements";
import ExtensionsRoutes from "./Extensions";
import PageLayoutsRoutes from "./PageLayouts";
import FactionRoutes from "./Faction";
import homeRoutes from "./Home";
import WalletRoutes from "./Wallet";
import AssetRoutes from "./Asset";
import LeaderboardRoutes from "./Leaderboard";
import ShipsRoutes from "./Ships";
import AssetsRoutes from "./Assets";
import J33vesRoutes from "./J33ves";

// ** Document title
const TemplateTitle = "%s - Vuexy React Admin Template";

// ** Default Route
const DefaultRoute = "/home";

// ** Merge Routes
const Routes = [
    ...homeRoutes,
    ...FactionRoutes,
    ...DashboardRoutes,
    ...AppRoutes,
    ...PagesRoutes,
    ...UiElementRoutes,
    ...ExtensionsRoutes,
    ...PageLayoutsRoutes,
    ...FormRoutes,
    ...TablesRoutes,
    ...ChartMapsRoutes,
    ...WalletRoutes,
    ...AssetRoutes,
    ...LeaderboardRoutes,
    ...ShipsRoutes,
    ...AssetsRoutes,
    ...J33vesRoutes,
];

export { DefaultRoute, TemplateTitle, Routes };
